// import: styles
import { Box } from '@mui/material';

// import: assets
import { ReactComponent as Cross } from 'core/assets/svg/common/cross.svg';
import BaseButton from 'core/components/button/BaseButton';
import BaseImage from 'core/components/image/BaseImage';
import {
	BannerBg,
	BannerText,
	GraphicLeft,
	GraphicRight,
	marketingBannerStyles,
} from 'core/layouts/components/marketing/marketing-banner/MarketingBannerStyles';
import {
	marketingBannerHeightPx,
	reusableStyles,
	tabletBreakpoint,
	tabsHeaderHeightPx,
} from 'core/layouts/ui-blocks/ReusableStyles';

// import: constants
import { BUY_CREDITS } from 'core/navigation/Routes';
// import: utils
// import: services
// import: redux
import {
	currentUserSelector,
	marketingBannerWorkingSelector,
	showMarketingBannerSelector,
	toggleShowMarketingBanner,
} from 'core/store/reducers/appReducer/AppSlice';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

// import: components
// import: lazy load components

function MarketingBanner({ showTabs = false }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const showMarketingBanner = useSelector(showMarketingBannerSelector);
	const marketingBannerWorking = useSelector(marketingBannerWorkingSelector);
	const currentUser = useSelector(currentUserSelector);

	const showBanner = useMemo(
		() => showMarketingBanner && marketingBannerWorking,
		[showMarketingBanner, marketingBannerWorking],
	);

	return (
		<Box
			id="marketting-banner-page-wrapper"
			// NOTE: PADDING_TOP CALCULATION
			sx={[
				reusableStyles.pageWrapper,
				{
					paddingTop: {
						xs: `calc(${showTabs === true ? tabsHeaderHeightPx : '0px'} + ${showBanner ? marketingBannerHeightPx : '0px'})`,
						[tabletBreakpoint]: `calc(${showBanner ? marketingBannerHeightPx : '0px'})`,
					},
				},
			]}
		>
			{currentUser ? (
				<Box
					id="marketting-banner-animation-wrapper"
					sx={[marketingBannerStyles.fixedMarketingBannerAnimationWrapper]}
				>
					<Box
						id="marketing-banner-wrapper"
						sx={[
							reusableStyles.flexCol,
							marketingBannerStyles.fixedMarketingBannerWrapper,
							{
								// NOTE: PADDING_TOP CALCULATION
								paddingTop: {
									xs: `${showTabs === true ? tabsHeaderHeightPx : '0px'}`,
									[tabletBreakpoint]: 0,
								},
							},
						]}
					>
						<Box
							id="marketing-banner-cont"
							sx={[
								marketingBannerStyles.MarketingBannerCont,
								{
									height: showBanner ? marketingBannerHeightPx : 0,
									minHeight: showBanner ? marketingBannerHeightPx : 0,
								},
							]}
						>
							<Box
								id="marketing-banner"
								sx={[
									marketingBannerStyles.MarketingBanner,
									{
										backgroundImage: `url(${BannerBg})`,
									},
								]}
								onClick={(e) => {
									e.stopPropagation();
									navigate(`/${BUY_CREDITS}`);
								}}
							>
								<Box sx={[{ height: 'inherit', minWidth: { xs: 0, [tabletBreakpoint]: '50px' } }]}>
									<Box sx={[{ height: 'inherit' }, reusableStyles.desktopOnly]}>
										<BaseImage src={GraphicLeft} alt="" />
									</Box>
								</Box>

								<Box
									sx={[
										reusableStyles.flexRow,
										{
											height: 'inherit',
											padding: { xs: '14px', [tabletBreakpoint]: '10px' },
										},
									]}
								>
									<BaseImage src={BannerText} alt="" />
								</Box>

								<Box sx={[reusableStyles.flexRow, { height: 'inherit' }]}>
									<Box sx={[{ height: 'inherit' }, reusableStyles.desktopOnly]}>
										<BaseImage src={GraphicRight} alt="" />
									</Box>
									<BaseButton
										id="close-marketing-banner"
										styles={[marketingBannerStyles.closeButton]}
										onClick={(e) => {
											e.stopPropagation();
											dispatch(toggleShowMarketingBanner(false));
										}}
									>
										<Cross />
									</BaseButton>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			) : (
				<Box />
			)}

			<Outlet />
		</Box>
	);
}

export default MarketingBanner;
